import * as React from 'react';

interface PageJumpToolDisplayProps {
  text: string;
}

const numDisplayStyle: React.CSSProperties = {
  width: '172px',
  height: '35px',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: '20px',
  marginRight: '20px',
  background: '#fff',
};

const textLabelStyle: React.CSSProperties = {
  paddingLeft: '10px',
  paddingRight: '10px',
  paddingTop: '5px',
  verticalAlign: 'middle',
  textAlign: 'right',
  fontSize: '1em',
  overflow: 'hidden',
};

const PageJumpToolDisplay: React.SFC<PageJumpToolDisplayProps> = (props) => {
  const { text } = props;

  return(
    <div style={numDisplayStyle}>
      <div style={textLabelStyle}>{text}</div>
    </div>
  );
};

export default PageJumpToolDisplay;
